import { JobsiteFilterKeyString } from 'InstitutionalManagement/types'
import { JOBSITE_FIELDS_INITIAL_VALUES } from './jobsiteFieldsInitialValues'

export const JOBSITE_INITIAL_FILTER: JobsiteFilterKeyString = {
  search: '',
  ...JOBSITE_FIELDS_INITIAL_VALUES,
}
